import { cloneElement } from 'react';
import { ButtonProps } from '../Button/Button';
import { ButtonLinkProps } from '../ButtonLink/ButtonLink';

export type InlineMessageActionType = React.ReactElement<
  ButtonProps | ButtonLinkProps
>;

type InlineMessageActionProps = {
  children: InlineMessageActionType;
};

const styles: ButtonProps = {
  intent: 'tertiary',
  size: 'small',
  width: 'fit',
};

export const InlineMessageAction = ({ children }: InlineMessageActionProps) =>
  // eslint-disable-next-line react-x/no-clone-element -- TODO: Wait! Don't change this file without seeing if you can remove this disable. It was added during a bulk version update, but fixing it would leave the park nicer than you found it. (Replace cloneElement with explicit prop passing.)
  cloneElement(children, { ...styles });

InlineMessageAction.displayName = 'InlineMessageAction';
